import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
import { VERTICAL_ALIGN } from 'EmailEditorUI/constants/SectionLayoutConstants';
export const SCROLL_AMOUNT = 15;
export const DRAG_PREVIEW_HEIGHT_PX = 80;
export const DRAG_PREVIEW_WIDTH_PX = 80;
const calcDeterminant = (line, point) => {
  return (point.x - line[0].x) * (line[1].y - line[0].y) - (point.y - line[0].y) * (line[1].x - line[0].x);
};
export const getDropTargetPositionForHoverBothDirections = (() => {
  let lastCacheKey = '';
  let lastCacheResult = {};
  return (dropTargetRect, mouseClientOffset) => {
    if (!mouseClientOffset || !dropTargetRect) {
      return {
        position: DropPosition.BEFORE,
        isVertical: false
      };
    }
    const cacheKey = JSON.stringify({
      dropTargetRect,
      mouseClientOffset
    });
    if (lastCacheKey === cacheKey) {
      return lastCacheResult;
    }
    lastCacheKey = cacheKey;

    /**
     *l1_____l2
     * |\   /|
     * | \ / |
     * |  v  |
     * | / \ |
     * |/___\|
     *l2    l1
     *
     * If point is to the left of line 2 it will be in 'after' position, both vertically and horizontally
     * If point lies both fully to left or right of either line, it is in vertical space
     **/
    const line1 = [{
      x: dropTargetRect.left,
      y: dropTargetRect.top
    }, {
      x: dropTargetRect.width + dropTargetRect.x,
      y: dropTargetRect.height + dropTargetRect.y
    }]; //top left to bottom right
    const line2 = [{
      x: dropTargetRect.width + dropTargetRect.x,
      y: dropTargetRect.top
    }, {
      x: dropTargetRect.left,
      y: dropTargetRect.height + dropTargetRect.y
    }]; // top right to bottom left

    const point = {
      x: mouseClientOffset.x,
      y: mouseClientOffset.y
    };
    const isLeftLine1 = calcDeterminant(line1, point) < 0;
    const isLeftLine2 = calcDeterminant(line2, point) < 0;
    lastCacheResult = {
      position: isLeftLine2 ? DropPosition.BEFORE : DropPosition.AFTER,
      isVertical: isLeftLine1 === isLeftLine2
    };
    return lastCacheResult;
  };
})();
export function getDropTargetPositionForHover(dropTargetRect, mouseClientOffset) {
  if (!mouseClientOffset || !dropTargetRect) {
    return DropPosition.BEFORE;
  }

  // Get vertical middle
  const sectionMiddleY = dropTargetRect.top + dropTargetRect.height / 2;
  if (mouseClientOffset.y <= sectionMiddleY) {
    return DropPosition.BEFORE;
  }
  return DropPosition.AFTER;
}
export function getDropPositionForColumn(verticalAlign, dropTargetRect, mouseClientOffset) {
  if (verticalAlign === VERTICAL_ALIGN.TOP) {
    return DropPosition.AFTER;
  }
  if (verticalAlign === VERTICAL_ALIGN.BOTTOM) {
    return DropPosition.BEFORE;
  }
  return getDropTargetPositionForHover(dropTargetRect, mouseClientOffset);
}